import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'access-agent-builder',
  version: '1.0.0',
  properties: [
    // ==================================================================
    // ENVIRONMENT SELECTION
    // No credentials required - uses Access Identity token
    // ==================================================================
    {
      key: 'environment',
      label: 'Environment',
      type: 'options',
      required: true,
      default: 'preprod',
      description: 'Select the Agent Builder environment',
      options: [
        { value: 'preprod', name: 'Pre-Production' },
        { value: 'staging', name: 'Staging' },
        { value: 'production', name: 'Production' },
      ],
    },

    // ==================================================================
    // OPERATION SELECTION
    // ==================================================================
    {
      key: 'operation',
      label: 'Operation',
      type: 'options',
      required: true,
      default: 'chatWithAgent',
      description: 'The operation to perform',
      options: [
        { value: 'chatWithAgent', name: 'Chat with Agent' },
        { value: 'listAgents', name: 'List Agents' },
        { value: 'getAgent', name: 'Get Agent Details' },
      ],
    },

    // ==================================================================
    // AGENT SELECTION (for chat and get operations)
    // ==================================================================
    {
      key: 'agentId',
      label: 'Agent',
      type: 'string',
      required: true,
      placeholder: 'Select an agent or enter ID',
      description: 'The agent to interact with',
      modeToggle: {
        enabled: true,
        defaultMode: 'data',
        loadOptions: {
          method: 'getAgents',
          dependsOn: ['environment'],
          cacheResults: true,
          cacheTtl: 60000,
          requiresCredential: false, // Uses Access Identity token, no credential needed
        },
        textModeLabel: 'Expression',
        dataModeLabel: 'Select',
      },
      displayOptions: {
        show: {
          operation: ['chatWithAgent', 'getAgent'],
        },
      },
    },

    // ==================================================================
    // CHAT MESSAGE
    // ==================================================================
    {
      key: 'message',
      label: 'Message',
      type: 'text',
      required: true,
      placeholder: 'Enter your message or prompt for the agent',
      description: 'The message/prompt to send to the agent',
      typeOptions: {
        rows: 4,
      },
      displayOptions: {
        show: {
          operation: ['chatWithAgent'],
        },
      },
    },

    // ==================================================================
    // CONVERSATION ID (optional - for multi-turn conversations)
    // ==================================================================
    {
      key: 'conversationId',
      label: 'Conversation ID',
      type: 'string',
      required: false,
      placeholder: 'Optional: conversation-uuid',
      description:
        'Optional conversation ID to maintain context across multiple invocations',
      displayOptions: {
        show: {
          operation: ['chatWithAgent'],
        },
      },
    },

    // ==================================================================
    // STREAMING (optional)
    // ==================================================================
    {
      key: 'streamResponse',
      label: 'Stream Response',
      type: 'boolean',
      required: false,
      default: false,
      description: 'Enable streaming for real-time response updates',
      displayOptions: {
        show: {
          operation: ['chatWithAgent'],
        },
      },
    },
  ],
};

export default schema;
